import MapListContainer from "../../../components/property/map/MapList";

const MapList = () => {
  return <MapListContainer />;
};

export default MapList;
